import ProfilePhoto from './ProfilePhoto';

export { ProfilePhoto };
